import { render, staticRenderFns } from "./multiselect-with-render-limit.vue?vue&type=template&id=1307de64&scoped=true"
import script from "./multiselect-with-render-limit.vue?vue&type=script&lang=ts"
export * from "./multiselect-with-render-limit.vue?vue&type=script&lang=ts"
import style0 from "./multiselect-with-render-limit.vue?vue&type=style&index=0&id=1307de64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1307de64",
  null
  
)

export default component.exports